import script from "./SessionLoadingSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionLoadingSkeleton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__